<template>
  <div
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    @click.self="$emit('close')"
  >
    <div
      class="relative w-full max-w-[800px] bg-white rounded-[20px] p-[40px] flex flex-col gap-[40px] max-h-[90vh] overflow-auto"
    >
      <div class="absolute right-10 top-10 cursor-pointer">
        <img
          class="w-[26px] h-[26px]"
          :src="cancel"
          alt=""
          @click="$emit('close')"
        />
      </div>
      <div class="text-4xl font-bold text-center">
        <h1>{{ getLocalized("form") }}</h1>
      </div>
      <div
        v-if="success"
        class="fixed top-4 right-4 max-w-xs w-full bg-green-500 text-white shadow-lg rounded-lg p-4 flex items-center space-x-3 transition-transform transform hover:scale-105"
      >
        <!-- Başarılı İkon -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 text-white"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8.5 8.5a1 1 0 01-1.414 0l-4.5-4.5a1 1 0 011.414-1.414L8 12.086l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>

        <!-- Toast Mesajı -->
        <div class="flex-1">
          <p class="font-bold">Success</p>
          <p class="text-sm">Successfully sent!</p>
        </div>
      </div>
      <!-- Name form -->
      <div class="flex flex-col gap-[20px]">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="flex flex-col" for="firstname">
              <h1 class="text-[16px] font-medium">
                {{ getLocalized("firstname") }}
              </h1>
              <input
                v-model="formData.firstName"
                class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow"
                type="text"
                :placeholder="getLocalized('firstname')"
              />
              <p v-if="errors.firstName" class="text-red-500 text-sm">
                {{ errors.firstName }}
              </p>
            </label>
          </div>
          <div>
            <label class="flex flex-col" for="lastname">
              <h1 class="text-[16px] font-medium">
                {{ getLocalized("lastname") }}
              </h1>
              <input
                v-model="formData.lastName"
                class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow"
                type="text"
                :placeholder="getLocalized('lastname')"
              />
              <p v-if="errors.lastName" class="text-red-500 text-sm">
                {{ errors.lastName }}
              </p>
            </label>
          </div>
        </div>
        <!-- Khmer name -->
        <div>
          <label class="flex flex-col" for="khmername">
            <h1 class="text-[16px] font-medium">
              {{ getLocalized("khmername") }}
            </h1>
            <input
              v-model="formData.khmername"
              class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow"
              type="text"
              :placeholder="getLocalized('khmername')"
            />
            <p v-if="errors.khmername" class="text-red-500 text-sm">
              {{ errors.khmername }}
            </p>
          </label>
        </div>
        <!-- Email -->
        <div>
          <label class="flex flex-col" for="email">
            <h1 class="text-[16px] font-medium">
              {{ getLocalized("email") }} <span class="text-tbt-red">*</span>
            </h1>
            <input
              v-model="formData.email"
              class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow"
              type="email"
              :placeholder="getLocalized('email')"
            />
            <p v-if="errors.email" class="text-red-500 text-sm">
              {{ errors.email }}
            </p>
          </label>
        </div>
        <!-- Date of birth / Gender -->
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="flex flex-col" for="birthdate">
              <h1 class="text-[16px] font-medium">
                {{ getLocalized("birthdate") }}
              </h1>
              <input
                v-model="formData.birthdate"
                class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow"
                type="date"
                :placeholder="getLocalized('birthdate')"
              />
              <p v-if="errors.birthdate" class="text-red-500 text-sm">
                {{ errors.birthdate }}
              </p>
            </label>
          </div>
          <div>
            <div>
              <label class="flex flex-col" for="gender">
                <h1 class="text-[16px] font-medium">
                  {{ getLocalized("gender") }}
                </h1>
                <select
                  v-model="formData.gender"
                  id="gender"
                  class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow"
                >
                  <option value="" disabled>
                    {{ getLocalized("gender") }}
                  </option>
                  <option value="male">{{ getLocalized("male") }}</option>
                  <option value="female">{{ getLocalized("female") }}</option>
                </select>
                <p v-if="errors.gender" class="text-red-500 text-sm">
                  {{ errors.gender }}
                </p>
              </label>
            </div>
          </div>
        </div>
        <!-- Education level -->
        <div class="grid grid-cols-2 gap-4">
          <div>
            <div>
              <label class="flex flex-col" for="education">
                <h1 class="text-[16px] font-medium">
                  {{ getLocalized("education") }}
                </h1>
                <select
                  v-model="formData.education"
                  id="education"
                  class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow"
                >
                  <option value="" disabled>
                    {{ getLocalized("education") }}
                  </option>

                  <!-- Loop through the education levels data -->
                  <option
                    v-for="(item, index) in educationLevel"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name_en }}
                  </option>
                </select>
                <p v-if="errors.education" class="text-red-500 text-sm">
                  {{ errors.education }}
                </p>
              </label>
            </div>
          </div>
          <!-- Major -->
          <div>
            <label class="flex flex-col" for="major">
              <h1 class="text-[16px] font-medium">
                {{ getLocalized("major") }}
              </h1>
              <input
                v-model="formData.major"
                class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow"
                type="text"
                :placeholder="getLocalized('major')"
              />
            </label>
            <p v-if="errors.major" class="text-red-500 text-sm">
              {{ errors.major }}
            </p>
          </div>
        </div>
        <!-- Phone Number -->
        <div>
          <label class="flex flex-col" for="tel">
            <h1 class="text-[16px] font-medium">
              {{ getLocalized("phone") }} <span class="text-tbt-red">*</span>
            </h1>
            <input
              v-model="formData.phone"
              class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow"
              type="tel"
              :placeholder="getLocalized('phone')"
            />
            <p v-if="errors.phone" class="text-red-500 text-sm">
              {{ errors.phone }}
            </p>
          </label>
        </div>
        <!-- Position -->
        <div>
          <label class="flex flex-col" for="position">
            <h1 class="text-[16px] font-medium">
              {{ getLocalized("position") }}
            </h1>
            <input
              v-model="formData.position_name"
              class="rounded-[8px] p-[20px] flex gap-[10px] bg-white-snow cursor-not-allowed placeholder-black"
              type="text"
              disabled="true"
            />
          </label>
        </div>

        <div>
          <label class="flex flex-col gap-2" for="text">
            <span class="text-[16px] font-medium">{{
              getLocalized("message")
            }}</span>
            <textarea
              v-model="formData.message"
              id="text"
              class="h-[173px] rounded-[8px] p-[20px] border border-gray-300 focus:outline-none focus:ring-2 focus:ring-tbt resize-none bg-white-snow"
              :placeholder="getLocalized('writeMsg')"
            ></textarea>
          </label>
        </div>
        <div>
          <!-- Drop Area -->
          <div
            class="h-[193px] w-full bg-white-snow border-2 border-dashed border-gray-300 rounded-lg flex justify-center items-center cursor-pointer"
            @dragover.prevent
            @drop.prevent="handleDrop"
            @dragenter.prevent
            @dragleave.prevent="dragActive = false"
            @click="triggerFileInput"
            :class="dragActive ? 'border-blue-500 bg-blue-50' : ''"
          >
            <p
              class="flex flex-col items-center text-center text-sm text-gray-600 space-y-2"
              v-if="!file"
            >
              <img :src="upload" alt="Upload icon" />
              <span>
                <p class="font-bold text-gray-900">Upload CV</p>
                <p class="text-gray-500">Supported file: PDF only</p>
              </span>
            </p>

            <p class="text-sm text-gray-800" v-else>
              {{ file.name }} ({{ (file.size / 1024).toFixed(1) }} KB)
            </p>
            <input
              type="file"
              accept=".pdf"
              class="hidden"
              ref="fileInput"
              @change="handleFileInput"
              multiple="false"
            />
          </div>
        </div>
      </div>
      <div>
        <button
          class="w-full bg-tbt-blue px-[32px] py-[16px] text-white rounded-[60px]"
          @click="handleSubmit"
        >
          {{ getLocalized("submit") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import upload from "@/assets/pictures/upload_b.svg";
import cancel from "@/assets/pictures/cancel.svg";
import axios from "axios";
export default {
  props: {
    position: { type: String, required: true },
    position_name: { type: String },
  },
  computed: {
    // Method to get the localized text based on the current language
    getLocalized() {
      return (key) => {
        return this.translations[key]
          ? this.translations[key][this.currentLang]
          : key;
      };
    },
  },
  data() {
    return {
      dragActive: false,
      file: null, // Holds the single file
      formData: {
        firstName: "",
        lastName: "",
        khmername: "",
        birthdate: "",
        gender: "",
        education: "",
        major: "",
        email: "",
        phone: "",
        position: this.position,
        position_name: this.position_name,
        message: "",
        file: "",
      },
      errors: {},
      loading: false,
      success: false,
      upload: upload,
      cancel: cancel,
      educationLevel: [],
      api: process.env.VUE_APP_API_KEY,
      translations: {
        form: {
          en: "Application Form",
          kh: "ពាក្យស្នើសុំ",
        },
        firstname: {
          en: "First Name",
          kh: "ត្រកូល",
        },
        lastname: {
          en: "Last Name",
          kh: "នាម",
        },
        khmername: {
          en: "Khmer Name",
          kh: "ឈ្មោះខ្មែរ",
        },
        education: {
          en: "Education Level",
          kh: "កម្រិតវប្បធម៏",
        },
        major: {
          en: "Major",
          kh: "ជំនាញ",
        },
        male: {
          en: "Male",
          kh: "ប្រុស",
        },
        female: {
          en: "Female",
          kh: "ស្រី",
        },
        email: {
          en: "Email",
          kh: "អ៊ីមែល",
        },
        birthdate: {
          en: "Date of Birth",
          kh: "ថ្ងៃ ខែ ឆ្នាំកំណើត",
        },
        phone: {
          en: "Phone Number ",
          kh: "លេខទូរស័ព្ទ",
        },
        gender: {
          en: "Gender",
          kh: "ភេទ",
        },
        position: {
          en: "Position",
          kh: "មុខតំណែង",
        },
        message: {
          en: "Message",
          kh: "សារ",
        },
        submit: {
          en: "Submit",
          kh: "ដាក់ស្នើ",
        },
        writeMsg: {
          en: "Write your message here...",
          kh: "សរសេរសាររបស់អ្នកនៅទីនេះ...",
        },
      },

      // Default language is from localStorage or 'en' if not set
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  mounted() {
    this.fetchEducationLevel();
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleDrop(event) {
      event.preventDefault();
      this.dragActive = false;
      const droppedFile = event.dataTransfer.files[0];

      if (droppedFile && droppedFile.type === "application/pdf") {
        this.file = droppedFile;
      } else {
        alert("Only PDF files are supported.");
      }
    },
    handleFileInput(event) {
      const selectedFile = event.target.files[0];

      if (selectedFile && selectedFile.type === "application/pdf") {
        this.file = selectedFile;
      } else {
        alert("Only PDF files are supported.");
      }
    },
    async handleSubmit() {
      try {
        // Validate fields
        if (!this.validateFields()) {
          return;
        }

        const formData = new FormData();

        // Append all fields
        formData.append("fname", this.formData.firstName);
        formData.append("lname", this.formData.lastName);
        formData.append("nameKh", this.formData.khmername);
        formData.append("email", this.formData.email);
        formData.append("educationLevel", this.formData.education);
        formData.append("major", this.formData.major);
        formData.append("canGender", this.formData.gender);
        formData.append("dateofbirth", this.formData.birthdate);
        formData.append("phonenumber", this.formData.phone);
        formData.append("position", this.formData.position);
        formData.append("message", this.formData.message || "");

        // Append file
        if (this.file) {
          formData.append("cv", this.file, this.file.name);
        }

        // Wait for the response and show loading for a bit
        await axios.post(
          `${this.api}/api/smarterp-api/submit-application`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.success = true;

        setTimeout(() => {
          this.$emit("close");
        }, 1000);
      } catch (error) {
        this.success = false;
        if (error.response) {
          this.success = false;

          alert("Please input the file");
        } else if (error.request) {
          alert("No response received from server");
        } else {
          console.error("Error setting up request:", error.message);
          alert("Error setting up request: " + error.message);
        }
      }
    },
    async fetchEducationLevel() {
      try {
        const response = await axios.get(
          this.api + "/api/smarterp-api/education-levels"
        );
        this.educationLevel = response.data.result;
      } catch (error) {
        console.error(error.message);
      }
    },

    // Validation

    validateFields() {
      const errors = {};

      if (!this.formData.firstName) {
        errors.firstName = "First name is required.";
      }
      if (!this.formData.lastName) {
        errors.lastName = "Last name is required.";
      }
      if (!this.formData.khmername) {
        errors.khmername = "Khmer name is required.";
      }
      if (!this.formData.email) {
        errors.email = "Email is required.";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
        errors.email = "Invalid email format.";
      }
      if (!this.formData.phone) {
        errors.phone = "Phone number is required.";
      } else if (!/^\d+$/.test(this.formData.phone)) {
        errors.phone = "Phone number must contain only digits.";
      } else if (this.formData.phone.length < 11) {
        errors.phone = "Phone number must be at least 11 characters ";
      }
      if (!this.formData.education) {
        errors.education = "Education level is required.";
      }
      if (!this.formData.major) {
        errors.major = "Major is required.";
      }
      if (!this.formData.gender) {
        errors.gender = "Gender is required.";
      }
      if (!this.formData.birthdate) {
        errors.birthdate = "Birthdate is required.";
      }

      this.errors = errors;

      return Object.keys(errors).length === 0;
    },
  },
};
</script>

<style scoped>
.fixed {
  display: flex;
  align-items: center;
  justify-content: center;
}

.relative {
  max-height: 90vh; /* Restrict the max height to 90% of the viewport */
  overflow-y: auto; /* Allow scrolling if the content exceeds the max height */
}

@media (max-width: 768px) {
  .relative {
    max-height: 90vh; /* Adjust max-height for smaller screens */
  }
}
</style>
